// @flow
import styled from "styled-components";
import colors from '../../../assets/css/colors';

export const ButtonSocial = styled.a`
	display: flex;
	background: transparent;
	align-items: center;
	cursor: pointer;
	width: 92%;
	height: 40px;
	border: 1px solid #d3d7db;
	border-radius: 6px;
	text-transform: uppercase;
	color: ${colors.nrlDarkGreen};
	font-weight: bold;
	font-size: 12px;
	margin: 1em 0;
	
	&:hover{
		background: ${colors.nrlGreen};
	}
	
	div{
		display: flex;
		justify-content: center;
		border-right: 1px solid #d3d7db;
		align-items: center;
		flex-basis: 12%;
		height: 100%;
		
		&.text{
			flex-basis: 88%;
		}
	}
`;

export default ButtonSocial;


// WEBPACK FOOTER //
// ./src/pages/league/invites/buttonSocial.js